import React, { Component } from 'react';
import ReactDOM from "react-dom"
import { ProgressBar, BottomBar, Header, ConfirmationModal } from './Components';
import StepQuantity from './Steps/StepQuantity';
import StepType from './Steps/StepType';
import StepSize from './Steps/StepSize';
import StepReviewOrder from './Steps/StepReviewOrder';
import { formatPriceCents } from '../../Helpers'; 
import { VARIANT_NAME_MAPPING, VARIANT_OPAQUE_QUANTITY } from '../../constants';
import { boldProductsQuery } from '../../ProductQuery';
import { base64EncodeProductId } from '../../cart_helpers';
import { presentmentPriceUnformatted } from '../../multi_currency';




const STEP_ORDER = [
	'StepQuantity',
	'StepType',
	'StepSize',
	'StepReviewOrder'
]

const SELECTORS = {
	productOptions: 'data-product-option',
	productTitle: 'data-product-title',
	productGroupId: 'data-product-groupId',
	productDescription: 'data-product-description',
	productId: 'data-product-id',
	discountPercent: 'data-product-discount',
	productVariants: 'data-product-variants'
}

class Box extends Component {
	constructor() {
		super();
		this.state = {
			currentStepIndex: 0,
			slots: [],
			typeOptions: [],
			quantityOptions: [],
			sizeOptions: [],
			selectedTypeOptions: [],
			dicount: 0,
			totalNoTax: 0,
			totalNoDiscount: 0,
			typeSelectionComplete: false,
			sizeChart: false,
			confirmationModal: false
		}
	}

	// helpers
	productQuantityFromTitle = (product_title) => parseInt(product_title.split(' ')[0])

	selectedQuantityOption = (quantity_options) => quantity_options.filter(option => option.selected)[0]

	selectedTypeOptions = (type_options) => type_options.filter(option => option.quantity > 0)

	selectedSize = (size_options) => size_options.filter(option => option.selected)[0]

	availableTypesFromSlots = (slots) => {

		const products = slots.map(slot => ({
			product_id: slot.product.product_id,
			title: slot.product.shopify_details.title,
			price: formatPriceCents(slot.product.shopify_details.variant.price),
			imgSrc: slot.product.shopify_details.images[0],
			quantity: 0
		}))
		const uniqueProducts = products.filter((product, pos, arr) => {
			return arr.map(obj => obj['product_id']).indexOf(product['product_id']) === pos
		})
		return uniqueProducts
	}

	priceDataForTypes = (products, shopifyProductData) => {
		return products.map(product => {
			const productData = shopifyProductData.nodes.filter(node => node.id === base64EncodeProductId(product.product_id))[0]
			return { ...product, presentmentPrices: productData.variants.edges[0].node.presentmentPrices }
		})
	}

	availableSizesFromSlots = (slots) => {
		const sizes = [...new Set(slots.map(slot => slot.product.shopify_details.variant.title))]
		return sizes.map(size => ({ size: size, selected: false }))
	}

	totalSelectedTypes = (selected_types) => selected_types.reduce((acc, next) => { return acc + next.quantity }, 0)

	totalSelectedOpaque = (selected_types) => selected_types.filter(type => type.title.toLowerCase().includes("opaque")).reduce((acc, next) => { return acc + next.quantity }, 0)

	selectedProductVariant = (selected_type_options, quantity_options) => {
		const totalOpaqueSelected = this.totalSelectedOpaque(selected_type_options)
		const selectedQuantityOption = this.selectedQuantityOption(quantity_options)
		const selectedVariant = selectedQuantityOption.productVariants.filter(variant => variant.quantityOpaque === totalOpaqueSelected)[0]
		return selectedVariant
	}

	progress = () => ((this.state.currentStepIndex + 1) / (STEP_ORDER.length + 1)) * 100

	formatVariants = (variants) => variants.map(variant => ({ ...variant, quantityOpaque: parseInt(variant.variantTitle.split('-')[0]) }))

	formatVariantsNew = (variants) => variants.map(variant => ({ ...variant, variantTitle: VARIANT_NAME_MAPPING[variant.variantTitle], variantTitleOriginal: variant.variantTitle, quantityOpaque: VARIANT_OPAQUE_QUANTITY[variant.variantTitle] }))

	// order total helpers 
	orderTotalNoTax = (line_items, discount, setCurrency) => {
		return line_items.reduce((acc, next) => { return acc + (parseFloat(formatPriceCents(presentmentPriceUnformatted(setCurrency, next.presentmentPrices))) * next.quantity) }, 0) * (1 - (discount / 100))
	}

	orderTotalNoDiscount = (line_items, setCurrency) => line_items.reduce((acc, next) => { return acc + (parseFloat(formatPriceCents(presentmentPriceUnformatted(setCurrency, next.presentmentPrices))) * next.quantity) }, 0)

	orderTax = (order_total) => order_total * 0.13;

	orderTotalWithTax = (total, tax) => total + tax;


	// Fetch Data
	getSlots = async (group_id, setCurrency) => {
		const shop = setCurrency == 'CAD' ? 'yourthreads-cad.myshopify.com' : 'yourthreads.myshopify.com'
		try {
			const res = await fetch(`https://ro.boldapps.net/api/widget/group/${group_id}/build_a_box/slots?shop=${shop}`)
			return await res.json()
		} catch (e) {
			console.log(e)
		}
	}

	getShopifyProductData = async (ids, client) => {
		console.log('Client', client)
		console.log('IDS', ids)

		const { data } = await client.query({
			query: boldProductsQuery(),
			variables: { ids: ids },
			fetchPolicy: 'network-only'
		})
		return data
	}




	// Option Selection Handlers 
	handleQuantitySelection = (selected_item) => {
		const updatedQuantityOptions = [...this.state.quantityOptions].map(option => ({ ...option, selected: option.productId === selected_item.productId }))
		this.setState({ quantityOptions: updatedQuantityOptions }, () => {
			clearTimeout(next);
			const next = setTimeout(() => { this.handleNextStep() }, 500)
		})
		return selected_item;
	}

	handleTypeSelection = (product_id, value) => {
		const total = this.selectedQuantityOption(this.state.quantityOptions).quantity
		const totalSelected = this.totalSelectedTypes(this.state.typeOptions)
		if (totalSelected < total || value < 0) {
			let updatedSelectedTypes = [...this.state.typeOptions].map(product => {
				return product.product_id === product_id ? { ...product, quantity: product.quantity + value > 0 ? product.quantity + value : 0 } : product
			})
			this.setState({
				typeOptions: updatedSelectedTypes,
				typeSelectionComplete: this.totalSelectedTypes(updatedSelectedTypes) == total
			})
		}
	}



	handleSizeSelection = (selected_item) => {
		const updatedSizeOptions = [...this.state.sizeOptions].map(option => ({ ...option, selected: option.size === selected_item.size }))
		this.setState({ sizeOptions: updatedSizeOptions }, () => {
			clearTimeout(next);
			const next = setTimeout(() => { this.handleNextStep() }, 500)
		})
	}



	// Other Event Handlers
	handleNextStep = () => {
		this.setState({ currentStepIndex: this.state.currentStepIndex + 1 })
	}

	handleBackStep = () => {
		this.setState({ currentStepIndex: this.state.currentStepIndex - 1 })
	}
	handleSizeChart = () => {
		this.setState({ sizeChart: !this.state.sizeChart })
	}

	handleConfirmationModal = () => {
		this.setState({ confirmationModal: !this.state.confirmationModal })
	}

	// render methods

	renderStep = (current_step_index) => {
		const currentStep = STEP_ORDER[current_step_index]

		switch (currentStep) {
			case 'StepQuantity':
				return <StepQuantity
					options={this.state.quantityOptions}
					handleSelection={this.handleQuantitySelection}
				/>
			case 'StepType':
				return <React.Fragment>
					<StepType
						options={this.state.typeOptions}
						selectedQuantityOption={this.selectedQuantityOption(this.state.quantityOptions)}
						handleTypeSelection={this.handleTypeSelection}
						setCurrency={this.props.setCurrency}
					/>
					<BottomBar
						handleNextStep={this.handleNextStep}
						totalNoTax={this.state.totalNoTax}
						totalNoDiscount={this.state.totalNoDiscount}
						buttonActive={this.state.typeSelectionComplete}
						hasNextButton={true}
						setCurrency={this.props.setCurrency}
					/>
				</React.Fragment>

			case 'StepSize':
				return <StepSize
					options={this.state.sizeOptions}
					handleSizeSelection={this.handleSizeSelection}
					sizeChart={this.state.sizeChart}
					handleSizeChart={this.handleSizeChart}
				/>
			case 'StepReviewOrder':
				return <React.Fragment>
					<StepReviewOrder
						typeOptions={this.state.selectedTypeOptions}
						totalNoTax={this.state.totalNoTax}
						tax={this.orderTax(this.state.totalNoTax)}
						total={this.orderTotalWithTax(this.state.totalNoTax, this.orderTax(this.state.totalNoTax))}
						selectedSize={this.selectedSize(this.state.sizeOptions)}
						totalNoDiscount={this.state.totalNoDiscount}
						setCurrency={this.props.setCurrency}
					/>
					<BottomBar
						handleNextStep={this.handleNextStep}
						totalNoTax={this.state.totalNoTax}
						totalNoDiscount={this.state.totalNoDiscount}
						hasCheckoutButton={true}
						selectedQuantityOption={this.selectedQuantityOption(this.state.quantityOptions)}
						selectedProductVariant={this.selectedProductVariant(this.state.selectedTypeOptions, this.state.quantityOptions)}
						selectedSize={this.selectedSize(this.state.sizeOptions)}
						slots={this.state.slots.slots}
						typeOptions={this.state.typeOptions}
						setCurrency={this.props.setCurrency}
						apiCreds={this.props.apiCreds}
					/>
				</React.Fragment>

		}
	}




	componentDidMount() {
		// From all products in build a box collection get product data and bold build a box group id

		const productOptions = document.querySelectorAll(`[${SELECTORS.productOptions}]`)
		const productOptionValues = Array.from(productOptions).map(option => ({
			productTitle: option.getAttribute(SELECTORS.productTitle),
			productGroupId: option.getAttribute(SELECTORS.productGroupId),
			productVariants: this.formatVariantsNew(JSON.parse(option.getAttribute(SELECTORS.productVariants))),
			quantity: this.productQuantityFromTitle(option.getAttribute(SELECTORS.productTitle)),
			description: option.getAttribute(SELECTORS.productDescription),
			productId: option.getAttribute(SELECTORS.productId),
			discountPercent: option.getAttribute(SELECTORS.discountPercent),
			selected: false
		}))
		this.setState({ quantityOptions: productOptionValues })
	}

	async componentDidUpdate(prevProps, prevState) {
		if (prevState.quantityOptions !== this.state.quantityOptions) {
			const selectedQuantity = this.selectedQuantityOption(this.state.quantityOptions)
			if (selectedQuantity) {
				console.log(selectedQuantity)
				const slots = await this.getSlots(selectedQuantity.productGroupId, this.props.setCurrency)
				console.log(slots)
				const products = this.availableTypesFromSlots(slots.slots)
				const uniqueProductIds = products.map(p => base64EncodeProductId(p.product_id))
				const shopifyProductData = await this.getShopifyProductData(uniqueProductIds, this.props.client)
				console.log('thistrudy', this.props.client)
				// this solution assumes all variants of a box product are the same price. variants are currently only size and this is true.
				const productsWithPrice = this.priceDataForTypes(products, shopifyProductData);
				const sizes = this.availableSizesFromSlots(slots.slots)
				this.setState({ slots: slots, typeOptions: productsWithPrice, sizeOptions: sizes })
			}
		}

		if (prevState.typeOptions !== this.state.typeOptions) {
			const { setCurrency } = this.props
			const selectedTypeOptions = this.selectedTypeOptions(this.state.typeOptions);
			const selectedQuantityOption = this.selectedQuantityOption(this.state.quantityOptions)
			const discount = selectedQuantityOption ? selectedQuantityOption.discountPercent : 0
			const totalNoTax = this.orderTotalNoTax(selectedTypeOptions, discount, setCurrency);
			const totalNoDiscount = this.orderTotalNoDiscount(selectedTypeOptions, setCurrency);
			this.setState({
				selectedTypeOptions: selectedTypeOptions,
				discount: discount,
				totalNoTax: totalNoTax,
				totalNoDiscount: totalNoDiscount
			})
		}
	}

	render() {
		const { currentStepIndex, selectedTypeOptions, discount, totalNoTax, totalNoDiscount, confirmationModal } = this.state;

		return (
			<div className="BoxBuilder">
				<ProgressBar progress={this.progress()} />
				<Header handleBackStep={this.handleBackStep} currentStepIndex={currentStepIndex} handleConfirmationModal={this.handleConfirmationModal} />
				{this.renderStep(currentStepIndex)}
				{confirmationModal &&
					<ConfirmationModal handleConfirmationModal={this.handleConfirmationModal} />
				}
			</div>
		)
	}
}

export default Box;